module.exports = __webpack_public_path__ + "static/media/girl-13.c94f6114.svg";